// src/utils.ts
function splitClass(className) {
  return className.split(" ").filter((x) => x);
}
var isBrowser = typeof window !== "undefined";
function addClass(els, className, omitAppendPrivateClass = false) {
  if (!className)
    return;
  const classNames = splitClass(className);
  if (!classNames.length)
    return;
  if (classNames.includes("longTouch"))
    return;
  for (const node of els) {
    if (!isNode(node) || !nodes.has(node)) {
      node.classList.add(...classNames);
      continue;
    }
    const privateClasses = [];
    const nodeData = nodes.get(node);
    if (!nodeData)
      continue;
    for (const className2 of classNames) {
      if (!node.classList.contains(className2)) {
        node.classList.add(className2);
      } else if (node.classList.contains(className2) && omitAppendPrivateClass === false) {
        privateClasses.push(className2);
      }
    }
    nodeData.privateClasses = privateClasses;
    nodes.set(node, nodeData);
  }
}
function removeClass(els, className) {
  if (!className)
    return;
  const classNames = splitClass(className);
  if (!classNames.length)
    return;
  for (const node of els) {
    if (!isNode(node)) {
      node.classList.remove(...classNames);
      continue;
    }
    const nodeData = nodes.get(node);
    if (!nodeData)
      continue;
    for (const className2 of classNames) {
      if (!nodeData.privateClasses.includes(className2)) {
        node.classList.remove(className2);
      }
    }
  }
}
function getScrollParent(node) {
  if (node == null)
    return void 0;
  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else if (node.parentNode instanceof HTMLElement) {
    return getScrollParent(node.parentNode);
  }
  return void 0;
}
function getElFromPoint(eventData) {
  if (!(eventData.e instanceof TouchEvent))
    return;
  const newX = eventData.e.touches[0].clientX;
  const newY = eventData.e.touches[0].clientY;
  const els = document.elementsFromPoint(newX, newY);
  if (!nodes)
    return;
  for (const node of els) {
    if (isNode(node) && nodes.has(node)) {
      const targetNode = node;
      const targetNodeData = nodes.get(targetNode);
      const targetParentData = parents.get(targetNode.parentNode);
      if (!targetNodeData || !targetParentData)
        return;
      return {
        node: {
          el: targetNode,
          data: targetNodeData
        },
        parent: {
          el: targetNode.parentNode,
          data: targetParentData
        }
      };
    } else if (node instanceof HTMLElement) {
      const parentData = parents.get(node);
      if (parentData) {
        return {
          parent: {
            el: node,
            data: parentData
          }
        };
      }
    }
  }
  return void 0;
}
function isNode(el) {
  return el instanceof HTMLElement && el.parentNode instanceof HTMLElement;
}
function addEvents(el, events) {
  const keysToControllers = {};
  for (const key in events) {
    const abortController = new AbortController();
    const event = events[key];
    el.addEventListener(key, event, {
      signal: abortController.signal
    });
    keysToControllers[key] = abortController;
  }
  return keysToControllers;
}
function copyNodeStyle(sourceNode, targetNode, omitKeys = false) {
  const computedStyle = window.getComputedStyle(sourceNode);
  const omittedKeys = [
    "position",
    "top",
    "left",
    "x",
    "y",
    "transform-origin",
    "filter",
    "-webkit-text-fill-color"
  ];
  for (const key of Array.from(computedStyle)) {
    if (omitKeys === false && key && omittedKeys.includes(key))
      continue;
    targetNode.style.setProperty(
      key,
      computedStyle.getPropertyValue(key),
      computedStyle.getPropertyPriority(key)
    );
  }
  for (const child of Array.from(sourceNode.children)) {
    if (!isNode(child))
      continue;
    const targetChild = targetNode.children[Array.from(sourceNode.children).indexOf(child)];
    copyNodeStyle(child, targetChild, omitKeys);
  }
}
function eventCoordinates(data) {
  return data instanceof DragEvent ? { x: data.clientX, y: data.clientY } : { x: data.touches[0].clientX, y: data.touches[0].clientY };
}

// src/plugins/multiDrag/index.ts
function multiDrag(multiDragConfig = {}) {
  return (parent) => {
    const parentData = parents.get(parent);
    if (!parentData)
      return;
    return {
      tearDownParent() {
      },
      setupParent() {
        parentData.config.multiDragConfig = multiDragConfig;
        parentData.config.handleDragstart = multiDragConfig.handleDragstart || handleDragstart;
        parentData.config.handleTouchstart = multiDragConfig.handleTouchstart || handleTouchstart;
        parentData.config.handleDragend = multiDragConfig.handleDragend || handleDragend;
        parentData.config.reapplyDragClasses = multiDragConfig.reapplyDragClasses || reapplyDragClasses;
        remapNodes(parent);
      }
    };
  };
}
function reapplyDragClasses(node, parentData) {
  if (!state)
    return;
  const dropZoneClass = "touchedNode" in state ? parentData.config.multiDragConfig.touchDropZoneClass : parentData.config.multiDragConfig.dropZoneClass;
  const draggedNodeEls = state.draggedNodes.map((x) => x.el);
  if (!draggedNodeEls.includes(node))
    return;
  addClass([node], dropZoneClass, true);
}
function handleDragend(data) {
  if (!state)
    return;
  end(data, state);
  selectionsEnd(data);
  resetState();
}
function selectionsEnd(data) {
  const config = data.targetData.parent.data.config;
  const multiDragconfig = data.targetData.parent.data.config.multiDragConfig;
  const root = config.root || document;
  const isTouch = state && "touchedNode" in state;
  const dropZoneClass = isTouch ? multiDragconfig.selectionDropZoneClass : multiDragconfig.touchSelectionDraggingClass;
  if (dropZoneClass) {
    const elsWithDropZoneClass = root.querySelectorAll(
      `.${splitClass(dropZoneClass)}`
    );
    removeClass(Array.from(elsWithDropZoneClass), dropZoneClass);
  }
}
function handleDragstart(data) {
  if (!(data.e instanceof DragEvent))
    return;
  dragstart({
    e: data.e,
    targetData: data.targetData
  });
}
function dragstart(data) {
  const dragState = initDrag(data);
  const multiDragConfig = data.targetData.parent.data.config.multiDragConfig;
  const selectedValues = multiDragConfig.selections && multiDragConfig.selections(data.targetData.parent.el);
  const originalZIndex = data.targetData.node.el.style.zIndex;
  dragState.originalZIndex = originalZIndex;
  data.targetData.node.el.style.zIndex = "9999";
  if (Array.isArray(selectedValues) && selectedValues.length) {
    const targetRect = data.targetData.node.el.getBoundingClientRect();
    const [x, y] = [
      data.e.clientX - targetRect.left,
      data.e.clientY - targetRect.top
    ];
    stackNodes(handleSelections(data, selectedValues, dragState, x, y));
  } else {
    const config = data.targetData.parent.data.config;
    dragstartClasses(
      dragState.draggedNode.el,
      config.draggingClass,
      config.dropZoneClass
    );
  }
}
function handleTouchstart(data) {
  if (!(data.e instanceof TouchEvent))
    return;
  touchstart({
    e: data.e,
    targetData: data.targetData
  });
}
function touchstart(data) {
  const touchState = initTouch(data);
  const multiDragConfig = data.targetData.parent.data.config.multiDragConfig;
  const selectedValues = multiDragConfig?.selections && multiDragConfig?.selections(data.targetData.parent.el);
  if (Array.isArray(selectedValues) && selectedValues.length) {
    stackNodes(
      handleSelections(
        data,
        selectedValues,
        touchState,
        touchState.touchStartLeft,
        touchState.touchStartTop
      )
    );
  } else {
    handleTouchedNode(data, touchState);
  }
  handleLongTouch(data, touchState);
}
function handleSelections(data, selectedValues, state2, x, y) {
  for (const child of data.targetData.parent.data.enabledNodes) {
    if (child === state2.draggedNode.el)
      continue;
    const childData = nodes.get(child);
    if (!childData)
      continue;
    if (!selectedValues.includes(childData.value))
      continue;
    state2.draggedNodes.push({
      el: child,
      data: childData
    });
  }
  const config = data.targetData.parent.data.config.multiDragConfig;
  const clonedEls = state2.draggedNodes.map((x2) => {
    const el = x2.el.cloneNode(true);
    copyNodeStyle(x2.el, el, true);
    if (data.e instanceof DragEvent)
      addClass([el], config.draggingClass);
    return el;
  });
  setTimeout(() => {
    if (data.e instanceof DragEvent) {
      addClass(
        state2.draggedNodes.map((x2) => x2.el),
        config.dropZoneClass
      );
    }
  });
  state2.clonedDraggedEls = clonedEls;
  return { data, state: state2, x, y };
}
function stackNodes({
  data,
  state: state2,
  x,
  y
}) {
  const wrapper = document.createElement("div");
  for (const el of state2.clonedDraggedEls)
    wrapper.append(el);
  const { width } = state2.draggedNode.el.getBoundingClientRect();
  wrapper.style.cssText = `
        display: flex;
        flex-direction: column;
        width: ${width}px;
        position: absolute;
        left: -9999px
      `;
  document.body.append(wrapper);
  if (data.e instanceof DragEvent) {
    data.e.dataTransfer?.setDragImage(wrapper, x, y);
    setTimeout(() => {
      wrapper.remove();
    });
  } else if ("touchedNode" in state2) {
    state2.touchedNode = wrapper;
  }
}

// src/plugins/animations/index.ts
function animations(animationsConfig = {}) {
  return () => {
    return {
      setupParent() {
        const style = document.createElement("style");
        if (document.head.querySelector("[data-drag-and-drop]"))
          return;
        style.innerHTML = `
          .drag-and-drop-slide-up {
            animation-name: slideUp;
            animation-duration: ${(animationsConfig.duration || 200) / 1e3}s;
          }

          @keyframes slideUp {
            from {
              transform: translateY(100%);
            }
            to {
              transform: translateY(0);
            }
          }

          .drag-and-drop-slide-down {
            animation-name: slideDown;
            animation-duration: ${(animationsConfig.duration || 200) / 1e3}s;
          }

          @keyframes slideDown {
            from {
              transform: translateY(-100%);
            }
            to {
              transform: translateY(0%);
            }
          }

          .drag-and-drop-slide-left {
            animation-name: slideLeft;
            animation-duration: ${(animationsConfig.duration || 200) / 1e3}s;
          }

          @keyframes slideLeft {
            from {
              transform: translateX(100%);
            }
            to {
              transform: translateX(0%);
            }
          }

          .drag-and-drop-slide-right {
            animation-name: slideRight;
            animation-duration: ${(animationsConfig.duration || 200) / 1e3}s;
          }

          @keyframes slideRight {
            from {
              transform: translateX(-100%);
            }
            to {
              transform: translateX(0);
            }
          }
        `;
        style.setAttribute("type", "text/css");
        style.setAttribute("data-drag-and-drop", "true");
        document.head.append(style);
      },
      setupNode(data) {
        if (!state)
          return;
        const nodeValue = data.nodeData.value;
        if (nodeValue !== state.swappedNodeValue)
          return;
        state.preventSortValue = nodeValue;
        switch (state.incomingDirection) {
          case "below":
            setClasses(
              data.node,
              state.draggedNode.el,
              "drag-and-drop-slide-down",
              "drag-and-drop-slide-up",
              animationsConfig.duration || 200
            );
            break;
          case "above":
            setClasses(
              data.node,
              state.draggedNode.el,
              "drag-and-drop-slide-up",
              "drag-and-drop-slide-down",
              animationsConfig.duration || 200
            );
            break;
          case "left":
            setClasses(
              data.node,
              state.draggedNode.el,
              "drag-and-drop-slide-left",
              "drag-and-drop-slide-right",
              animationsConfig.duration || 200
            );
            break;
          case "right":
            setClasses(
              data.node,
              state.draggedNode.el,
              "drag-and-drop-slide-right",
              "drag-and-drop-slide-left",
              animationsConfig.duration || 200
            );
            break;
        }
      }
    };
  };
}
function setClasses(node, draggedNode, nodeClass, draggedNodeClass, duration) {
  node.classList.add(nodeClass);
  draggedNode.classList.add(draggedNodeClass);
  setTimeout(() => {
    if (!state)
      return;
    state.preventSortValue = void 0;
    draggedNode.classList.remove(draggedNodeClass);
    node.classList.remove(nodeClass);
  }, duration);
}

// src/index.ts
var nodes = /* @__PURE__ */ new WeakMap();
var parents = /* @__PURE__ */ new WeakMap();
var parentObservers = /* @__PURE__ */ new WeakMap();
var state = void 0;
function resetState() {
  state = void 0;
}
function setDragState(dragStateProps2) {
  state = {
    incomingDirection: void 0,
    enterCount: 0,
    lastValue: void 0,
    preventEnter: false,
    clonedDraggedEls: [],
    swappedNodeValue: false,
    preventSortValue: void 0,
    originalZIndex: void 0,
    ...dragStateProps2
  };
  return state;
}
function setTouchState(dragState, touchStateProps) {
  state = {
    ...dragState,
    ...touchStateProps
  };
  return state;
}
function dragStateProps(targetData) {
  return {
    draggedNode: {
      el: targetData.node.el,
      data: targetData.node.data
    },
    draggedNodes: [
      {
        el: targetData.node.el,
        data: targetData.node.data
      }
    ],
    initialParent: {
      el: targetData.parent.el,
      data: targetData.parent.data
    },
    lastParent: {
      el: targetData.parent.el,
      data: targetData.parent.data
    }
  };
}
function performSort(state2, data) {
  const draggedValues = dragValues(state2);
  const targetParentValues = parentValues(
    data.targetData.parent.el,
    data.targetData.parent.data
  );
  const newParentValues = [
    ...targetParentValues.filter((x) => !draggedValues.includes(x))
  ];
  newParentValues.splice(data.targetData.node.data.index, 0, ...draggedValues);
  setParentValues(data.targetData.parent.el, data.targetData.parent.data, [
    ...newParentValues
  ]);
}
function parentValues(parent, parentData) {
  return [...parentData.getValues(parent)];
}
function setParentValues(parent, parentData, values) {
  parentData.setValues(parent, values);
}
function dragValues(state2) {
  return [...state2.draggedNodes.map((x) => x.data.value)];
}
function initParent({
  parent,
  getValues,
  setValues,
  config = {}
}) {
  if (!isBrowser)
    return;
  document.addEventListener("dragover", (e) => {
    e.preventDefault();
  });
  tearDownParent(parent);
  const parentData = {
    getValues,
    setValues,
    config: {
      handleDragstart: handleDragstart2,
      handleDragoverNode,
      handleDragoverParent,
      handleDragend: handleDragend2,
      handleTouchstart: handleTouchstart2,
      handleTouchmove,
      handleTouchOverNode,
      handleTouchOverParent,
      performSort,
      performTransfer,
      root: document,
      setupNode,
      reapplyDragClasses: reapplyDragClasses2,
      tearDownNode,
      threshold: {
        horizontal: 0,
        vertical: 0
      },
      ...config
    },
    enabledNodes: [],
    abortControllers: {}
  };
  setupParent(parent, parentData);
  config.plugins?.forEach((plugin) => {
    plugin(parent)?.tearDownParent?.();
  });
  remapNodes(parent);
  config.plugins?.forEach((plugin) => {
    plugin(parent)?.setupParent?.();
  });
}
function tearDownParent(parent) {
  const parentData = parents.get(parent);
  if (!parentData)
    return;
  for (const event of Object.keys(parentData.abortControllers["mainParent"])) {
    parentData.abortControllers["mainParent"][event].abort();
  }
  for (const node of Array.from(parent.children)) {
    if (isNode(node)) {
      nodes.delete(node);
    }
  }
  parents.delete(parent);
  const parentObserver = parentObservers.get(parent.parentNode);
  if (parentObserver)
    parentObserver.disconnect();
  parentObservers.delete(parent);
}
function setupParent(parent, parentData) {
  const nodesObserver = new MutationObserver(nodesMutated);
  nodesObserver.observe(parent, { childList: true });
  if (parent.parentNode) {
    const parentObserver = new MutationObserver(parentMutated);
    parentObserver.observe(parent.parentNode, { childList: true });
    if (!(parent.parentNode instanceof HTMLElement))
      return;
    parentObservers.set(parent.parentNode, parentObserver);
  }
  parents.set(parent, { ...parentData });
  const abortControllers = addEvents(parent, {
    dragover: parentEventData(parentData.config.handleDragoverParent),
    touchOverParent: parentData.config.handleTouchOverParent
  });
  parentData.abortControllers["mainParent"] = abortControllers;
}
function parentMutated(mutationList) {
  for (const mutation of mutationList) {
    for (const removedNode of Array.from(mutation.removedNodes)) {
      if (!(removedNode instanceof HTMLElement))
        continue;
      const parentData = parents.get(removedNode);
      if (!parentData)
        continue;
      for (const node of Array.from(removedNode.childNodes)) {
        if (isNode(node) && parentData.enabledNodes.includes(node)) {
          nodes.delete(node);
        }
      }
      parents.delete(removedNode);
    }
  }
}
function nodesMutated(mutationList) {
  const parentEl = mutationList[0].target;
  if (!(parentEl instanceof HTMLElement))
    return;
  remapNodes(parentEl);
}
function remapNodes(parent) {
  const parentData = parents.get(parent);
  if (!parentData)
    return;
  const enabledNodes = [];
  const config = parentData.config;
  for (let x = 0; x < parent.children.length; x++) {
    const node = parent.children[x];
    if (!isNode(node))
      continue;
    const nodeData = nodes.get(node);
    config.tearDownNode({ node, parent, nodeData, parentData });
    if (config.disabled)
      return;
    if (!config.draggable || config.draggable && config.draggable(node))
      enabledNodes.push(node);
  }
  if (enabledNodes.length !== parentData.getValues(parent).length && !config.disabled) {
    console.warn(
      "The number of enabled nodes does not match the number of values."
    );
    return;
  }
  const values = parentData.getValues(parent);
  for (let x = 0; x < enabledNodes.length; x++) {
    const node = enabledNodes[x];
    const nodeData = {
      value: values[x],
      index: x,
      privateClasses: [],
      abortControllers: {}
    };
    if (state && nodeData.value === state.draggedNode.data.value) {
      state.draggedNode.data = nodeData;
      state.draggedNode.el = node;
    }
    if (state && state.draggedNodes.map((x2) => x2.data.value).includes(nodeData.value)) {
      const draggedNode = state.draggedNodes.find(
        (x2) => x2.data.value === nodeData.value
      );
      if (draggedNode)
        draggedNode.el = node;
    }
    config.setupNode({ node, parent, parentData, nodeData });
  }
  parents.set(parent, { ...parentData, enabledNodes });
  if (state)
    state.preventEnter = false;
}
function handleDragstart2(data) {
  if (!(data.e instanceof DragEvent))
    return;
  dragstart2({
    e: data.e,
    targetData: data.targetData
  });
}
function dragstartClasses(el, draggingClass, dropZoneClass) {
  addClass([el], draggingClass);
  setTimeout(() => {
    removeClass([el], draggingClass);
    addClass([el], dropZoneClass);
  });
}
function initDrag(eventData) {
  const dragState = setDragState(dragStateProps(eventData.targetData));
  if (eventData.e.dataTransfer) {
    eventData.e.dataTransfer.dropEffect = "move";
    eventData.e.dataTransfer.effectAllowed = "move";
  }
  return dragState;
}
function validateDragHandle(data) {
  if (!(data.e instanceof DragEvent) && !(data.e instanceof TouchEvent))
    return false;
  const config = data.targetData.parent.data.config;
  if (!config.dragHandle)
    return true;
  const dragHandles = data.targetData.node.el.querySelectorAll(
    config.dragHandle
  );
  if (!dragHandles)
    return false;
  const coordinates = eventCoordinates(data.e);
  const elFromPoint = config.root.elementFromPoint(
    coordinates.x,
    coordinates.y
  );
  if (!elFromPoint)
    return false;
  for (const handle of Array.from(dragHandles)) {
    if (elFromPoint === handle || handle.contains(elFromPoint))
      return true;
  }
  return false;
}
function touchstart2(data) {
  if (!validateDragHandle(data)) {
    data.e.preventDefault();
    return;
  }
  const touchState = initTouch(data);
  handleTouchedNode(data, touchState);
  handleLongTouch(data, touchState);
}
function dragstart2(data) {
  if (!validateDragHandle(data)) {
    data.e.preventDefault();
    return;
  }
  const config = data.targetData.parent.data.config;
  const dragState = initDrag(data);
  const originalZIndex = data.targetData.node.el.style.zIndex;
  dragState.originalZIndex = originalZIndex;
  data.targetData.node.el.style.zIndex = "9999";
  dragstartClasses(
    dragState.draggedNode.el,
    config.draggingClass,
    config.dropZoneClass
  );
}
function handleTouchOverNode(e) {
  if (!state)
    return;
  if (state.draggedNode.el === e.detail.targetData.node.el)
    return;
  if (e.detail.targetData.parent.el === state.lastParent.el)
    sort(e.detail, state);
}
function setupNode(data) {
  nodes.set(data.node, data.nodeData);
  const config = data.parentData.config;
  data.node.setAttribute("draggable", "true");
  const abortControllers = addEvents(data.node, {
    dragstart: nodeEventData(config.handleDragstart),
    dragover: nodeEventData(config.handleDragoverNode),
    dragend: nodeEventData(config.handleDragend),
    touchstart: nodeEventData(config.handleTouchstart),
    touchmove: nodeEventData(config.handleTouchmove),
    touchend: nodeEventData(config.handleDragend),
    touchOverNode: config.handleTouchOverNode
  });
  data.nodeData.abortControllers["mainNode"] = abortControllers;
  data.parentData.config.plugins?.forEach((plugin) => {
    plugin(data.parent)?.setupNode?.(data);
  });
  config.reapplyDragClasses(data.node, data.parentData);
  if (!state)
    return;
}
function reapplyDragClasses2(node, parentData) {
  if (!state)
    return;
  const dropZoneClass = "touchedNode" in state ? parentData.config.touchDropZoneClass : parentData.config.dropZoneClass;
  if (state.draggedNode.el !== node)
    return;
  addClass([node], dropZoneClass, true);
}
function tearDownNode(data) {
  data.node.setAttribute("draggable", "false");
  if (data.nodeData?.abortControllers?.mainNode) {
    for (const event of Object.keys(data.nodeData.abortControllers.mainNode)) {
      data.nodeData.abortControllers.mainNode[event].abort();
    }
  }
  data.parentData.config.plugins?.forEach((plugin) => {
    plugin(data.parent)?.tearDownNode?.(data);
  });
  nodes.delete(data.node);
}
function handleDragend2(eventData) {
  if (!state)
    return;
  end(eventData, state);
  resetState();
}
function end(_eventData, state2) {
  if ("longTouchTimeout" in state2 && state2.longTouchTimeout)
    clearTimeout(state2.longTouchTimeout);
  const config = parents.get(state2.initialParent.el)?.config;
  const root = config?.root || document;
  const isTouch = "touchedNode" in state2;
  const dropZoneClass = isTouch ? config?.touchDropZoneClass : config?.dropZoneClass;
  if (state2.originalZIndex !== void 0)
    state2.draggedNode.el.style.zIndex = state2.originalZIndex;
  addClass(
    state2.draggedNodes.map((x) => x.el),
    dropZoneClass,
    true
  );
  if (dropZoneClass) {
    const elsWithDropZoneClass = root.querySelectorAll(
      `.${splitClass(dropZoneClass)}`
    );
    removeClass(Array.from(elsWithDropZoneClass), dropZoneClass);
  }
  if (config?.longTouchClass) {
    removeClass(
      state2.draggedNodes.map((x) => x.el),
      state2.initialParent.data?.config?.longTouchClass
    );
  }
  if ("touchedNode" in state2) {
    state2.touchedNode?.remove();
    if (state2.scrollParent) {
      state2.scrollParent.style.overflow = state2.scrollParentOverflow || "";
    }
  }
}
function handleTouchstart2(eventData) {
  if (!(eventData.e instanceof TouchEvent))
    return;
  touchstart2({
    e: eventData.e,
    targetData: eventData.targetData
  });
}
function initTouch(data) {
  data.e.stopPropagation();
  const clonedNode = data.targetData.node.el.cloneNode(true);
  const rect = data.targetData.node.el.getBoundingClientRect();
  const touchState = setTouchState(
    setDragState(dragStateProps(data.targetData)),
    {
      touchStartLeft: data.e.touches[0].clientX - rect.left,
      touchStartTop: data.e.touches[0].clientY - rect.top,
      touchedNode: clonedNode
    }
  );
  return touchState;
}
function handleTouchedNode(data, touchState) {
  touchState.touchedNodeDisplay = touchState.touchedNode.style.display;
  const rect = data.targetData.node.el.getBoundingClientRect();
  touchState.touchedNode.style.cssText = `
            width: ${rect.width}px;
            position: absolute;
            pointer-events: none;
            top: -9999px;
            z-index: 999999;
            display: none;
          `;
  document.body.append(touchState.touchedNode);
  copyNodeStyle(data.targetData.node.el, touchState.touchedNode);
  touchState.touchedNode.style.display = "none";
}
function handleLongTouch(data, touchState) {
  const config = data.targetData.parent.data.config;
  if (!config.longTouch)
    return;
  touchState.longTouchTimeout = setTimeout(() => {
    if (!touchState)
      return;
    touchState.longTouch = true;
    const parentScroll = getScrollParent(touchState.draggedNode.el);
    if (parentScroll) {
      touchState.scrollParent = parentScroll;
      touchState.scrollParentOverflow = parentScroll.style.overflow;
      parentScroll.style.overflow = "hidden";
    }
    if (config.longTouchClass && data.e.cancelable)
      addClass(
        touchState.draggedNodes.map((x) => x.el),
        config.longTouchClass
      );
    data.e.preventDefault();
    document.addEventListener("contextmenu", function(e) {
      e.preventDefault();
    });
  }, config.longTouchTimeout || 200);
}
function handleTouchmove(eventData) {
  if (!state || !("touchedNode" in state))
    return;
  touchmove(eventData, state);
}
function touchmoveClasses(touchState, config) {
  if (config.longTouchClass)
    removeClass(
      touchState.draggedNodes.map((x) => x.el),
      config?.longTouchClass
    );
  if (config.touchDraggingClass)
    addClass([touchState.touchedNode], config.touchDraggingClass);
  if (config.touchDropZoneClass)
    addClass(
      touchState.draggedNodes.map((x) => x.el),
      config.touchDropZoneClass
    );
}
function moveTouchedNode(data, touchState) {
  touchState.touchedNode.style.display = touchState.touchedNodeDisplay || "";
  const x = data.e.touches[0].clientX + window.scrollX;
  const y = data.e.touches[0].clientY + window.scrollY;
  const windowHeight = window.innerHeight + window.scrollY;
  if (y > windowHeight - 50) {
    window.scrollBy(0, 10);
  } else if (y < window.scrollY + 50) {
    window.scrollBy(0, -10);
  }
  const touchStartLeft = touchState.touchStartLeft ?? 0;
  const touchStartTop = touchState.touchStartTop ?? 0;
  touchState.touchedNode.style.left = `${x - touchStartLeft}px`;
  touchState.touchedNode.style.top = `${y - touchStartTop}px`;
}
function touchmove(data, touchState) {
  if (data.e.cancelable)
    data.e.preventDefault();
  const config = data.targetData.parent.data.config;
  if (config.longTouch && !touchState.longTouch) {
    clearTimeout(touchState.longTouchTimeout);
    return;
  }
  if (touchState.touchMoving !== true) {
    touchState.touchMoving = true;
    touchmoveClasses(touchState, config);
  }
  moveTouchedNode(data, touchState);
  const elFromPoint = getElFromPoint(data);
  if (!elFromPoint)
    return;
  if ("node" in elFromPoint && elFromPoint.node.el === touchState.draggedNodes[0].el) {
    touchState.lastValue = data.targetData.node.data.value;
    return;
  }
  const touchMoveEventData = {
    e: data.e,
    targetData: elFromPoint
  };
  if ("node" in elFromPoint) {
    elFromPoint.node.el.dispatchEvent(
      new CustomEvent("touchOverNode", {
        detail: touchMoveEventData
      })
    );
  } else {
    elFromPoint.parent.el.dispatchEvent(
      new CustomEvent("touchOverParent", {
        detail: touchMoveEventData
      })
    );
  }
}
function handleDragoverNode(data) {
  if (!state)
    return;
  dragoverNode(data, state);
}
function handleDragoverParent(eventData) {
  if (!state)
    return;
  transfer(eventData, state);
}
function handleTouchOverParent(e) {
  if (!state)
    return;
  transfer(e.detail, state);
}
function validateTransfer(data, state2) {
  if (data.targetData.parent.el === state2.lastParent.el)
    return false;
  const targetConfig = data.targetData.parent.data.config;
  if (targetConfig.dropZone === false)
    return false;
  const initialParentConfig = state2.initialParent.data.config;
  if (targetConfig.accepts && !targetConfig.accepts(
    data.targetData.parent,
    state2.initialParent,
    state2.lastParent,
    state2
  )) {
    return false;
  } else if (!targetConfig.group || targetConfig.group !== initialParentConfig.group) {
    return false;
  }
  return true;
}
function dragoverNode(eventData, dragState) {
  eventData.e.preventDefault();
  if (dragState.draggedNodes.map((x) => x.el).includes(eventData.targetData.node.el))
    return;
  eventData.targetData.parent.el === dragState.lastParent?.el ? sort(eventData, dragState) : transfer(eventData, dragState);
}
function validateSort(data, state2, x, y) {
  if (!state2)
    return false;
  if (state2.preventEnter)
    return false;
  if (state2.preventSortValue === data.targetData.node.data.value)
    return false;
  if (data.targetData.parent.el !== state2.lastParent?.el)
    return false;
  const targetRect = data.targetData.node.el.getBoundingClientRect();
  const dragRect = state2.draggedNode.el.getBoundingClientRect();
  const yDiff = targetRect.y - dragRect.y;
  const xDiff = targetRect.x - dragRect.x;
  let incomingDirection;
  if (Math.abs(yDiff) > Math.abs(xDiff)) {
    incomingDirection = yDiff > 0 ? "above" : "below";
  } else {
    incomingDirection = xDiff > 0 ? "left" : "right";
  }
  const threshold = state2.lastParent.data.config.threshold;
  switch (incomingDirection) {
    case "left":
      if (x > targetRect.x + targetRect.width * threshold.horizontal) {
        state2.incomingDirection = "left";
        return true;
      }
      break;
    case "right":
      if (x < targetRect.x + targetRect.width * (1 - threshold.horizontal)) {
        state2.incomingDirection = "right";
        return true;
      }
      break;
    case "above":
      if (y > targetRect.y + targetRect.height * threshold.vertical) {
        state2.incomingDirection = "above";
        return true;
      }
      break;
    case "below":
      if (y < targetRect.y + targetRect.height * (1 - threshold.vertical)) {
        state2.incomingDirection = "below";
        return true;
      }
      break;
    default:
      break;
  }
  return false;
}
function sort(data, state2) {
  const { x, y } = eventCoordinates(data.e);
  if (!validateSort(data, state2, x, y))
    return;
  state2.swappedNodeValue = data.targetData.node.data.value;
  state2.preventEnter = true;
  data.targetData.parent.data.config.performSort(state2, data);
}
function nodeEventData(callback) {
  function nodeTargetData(node) {
    const nodeData = nodes.get(node);
    const parent = node.parentNode || state?.lastParent?.el;
    if (!nodeData)
      return;
    const parentData = parents.get(parent);
    if (!parentData)
      return;
    return {
      node: {
        el: node,
        data: nodeData
      },
      parent: {
        el: parent,
        data: parentData
      }
    };
  }
  return (e) => {
    const targetData = nodeTargetData(e.currentTarget);
    if (!targetData)
      return;
    return callback({
      e,
      targetData
    });
  };
}
function performTransfer(state2, data) {
  const draggedValues = dragValues(state2);
  const lastParentValues = parentValues(
    state2.lastParent.el,
    state2.lastParent.data
  ).filter((x) => !draggedValues.includes(x));
  const targetParentValues = parentValues(
    data.targetData.parent.el,
    data.targetData.parent.data
  );
  "node" in data.targetData ? targetParentValues.splice(
    data.targetData.node.data.index,
    0,
    ...draggedValues
  ) : targetParentValues.push(...draggedValues);
  setParentValues(state2.lastParent.el, state2.lastParent.data, lastParentValues);
  setParentValues(
    data.targetData.parent.el,
    data.targetData.parent.data,
    targetParentValues
  );
}
function transfer(data, state2) {
  if (!validateTransfer(data, state2))
    return;
  data.targetData.parent.data.config.performTransfer(state2, data);
  state2.lastParent = data.targetData.parent;
}
function parentEventData(callback) {
  function parentTargetData(parent) {
    const parentData = parents.get(parent);
    if (!parentData)
      return;
    return {
      parent: {
        el: parent,
        data: parentData
      }
    };
  }
  return (e) => {
    const targetData = parentTargetData(e.currentTarget);
    if (!targetData)
      return;
    return callback({
      e,
      targetData
    });
  };
}
export {
  animations,
  dragStateProps,
  dragValues,
  dragstart2 as dragstart,
  dragstartClasses,
  end,
  handleDragend2 as handleDragend,
  handleDragoverNode,
  handleDragoverParent,
  handleDragstart2 as handleDragstart,
  handleLongTouch,
  handleTouchOverNode,
  handleTouchOverParent,
  handleTouchedNode,
  handleTouchmove,
  handleTouchstart2 as handleTouchstart,
  initDrag,
  initParent,
  initTouch,
  multiDrag,
  nodeEventData,
  nodes,
  parentEventData,
  parentObservers,
  parentValues,
  parents,
  performSort,
  performTransfer,
  remapNodes,
  resetState,
  setDragState,
  setParentValues,
  setTouchState,
  setupNode,
  sort,
  state,
  tearDownNode,
  transfer,
  validateSort,
  validateTransfer
};
//# sourceMappingURL=index.js.map